import ActionType from './ActionType'
import { Auth } from 'utils/Auth'
import API_URL from 'utils/ApiUrl'

export const listScheduledEmails = () => (dispatch, getState) => {
  dispatch({ type: ActionType.Email.Templates.LIST_SCHEDULED_REQUEST })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/email/schedule`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'content-type': 'application/json',
            'authorization': headerValue
        },
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res => res.json())
        .then(payload => (
          dispatch({
            type: ActionType.Email.Templates.LIST_SCHEDULED_SUCCESS,
            payload
          })
        ))
        .catch(error => (
          dispatch({
            type: ActionType.Email.Templates.LIST_SCHEDULED_FAILURE,
            payload: error
          })
        ))
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const cancelScheduledEmail = id => (dispatch, getState) => {
  dispatch({ type: ActionType.Email.Templates.CANCEL_SCHEDULED_REQUEST, payload: id })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/email/schedule/${id}`, {
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'content-type': 'application/json',
            'authorization': headerValue
        },
        method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res => res.json())
        .then(payload => (
          dispatch({
            type: ActionType.Email.Templates.CANCEL_SCHEDULED_SUCCESS,
            payload
          })
        ))
        .catch(error => (
          dispatch({
            type: ActionType.Email.Templates.CANCEL_SCHEDULED_SUCCESS,
            payload: error
          })
        ))
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}

export const scheduleTemplatedEmailSend = data => (dispatch, getState) => {
  dispatch({
    type: ActionType.Email.Templates.SCHEDULE_REQUEST,
    payload: data
  })

  return Auth.currentSession()
    .then(session => {
      const headerValue = `Bearer ${session.idToken.jwtToken}`

      return fetch(`${API_URL}/email/schedule`, {
        body: JSON.stringify(data), // must match 'Content-Type' header
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'content-type': 'application/json',
            'authorization': headerValue
        },
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, cors, *same-origin
        redirect: 'follow', // manual, *follow, error
        referrer: 'no-referrer', // *client, no-referrer
      })
        .then(res => res.json())
        .then(payload => (
          dispatch({
            type: ActionType.Email.Templates.SCHEDULE_SUCCESS,
            payload
          })
        ))
        .then(() => dispatch(listScheduledEmails()))
        .catch(error => (
          dispatch({
            type: ActionType.Email.Templates.SCHEDULE_FAILURE,
            payload: error
          })
        ))
    })
    .catch(err => {
      console.log(err)
      if (err.code === 'UserNotFoundException') {
        window.localStorage.clear()
        window.location.reload(true)
      }
    })
}
